// extracted by mini-css-extract-plugin
module.exports = {"oldVersion":"oldVersion-kV8Nl","change":"change-3u9e_"};